import styles from "../styles/adminTabList.module.css";
import { AdminPageTabListItem } from "./adminPageTabListItem";

export const AdminPageTabList = ({
  tabs,
  onSelect,
  activeTab,
}: {
  tabs: any[];
  onSelect: (tab: any) => void;
  activeTab: any;
}) => {
  return (
    <div className={styles.wrapper}>
      {tabs.map((tab, index) => (
        <AdminPageTabListItem tab={tab} key={index} onSelect={onSelect} activeTab={activeTab} />
      ))}
    </div>
  );
};
